import {useHits} from "react-instantsearch-hooks-web";
import {useContext, useEffect} from "react";
import FilterContext from "./../Context/FilterContext";

const HitsUpdater = () => {
    const { hits } = useHits()
    const { hitsContainer, mapView } = useContext(FilterContext)

    useEffect(() => {
        mapView ? hitsContainer?.current.scrollTo(0, 0) : window.scrollTo(0, 0)
    }, [hits])
}

export default HitsUpdater